module.exports = __webpack_public_path__ + "static/GorditaBold-0e9da178db75360185b1556e58e4356f.woff";